
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'
import NewsItem from '~/components/pages/news/news-item/index.vue'

export default Vue.extend({
  name: 'NewsPage',
  components: {
    NewsItem
  },
  mixins: [
    mixins.news
  ],
  watch: {
    async '$route.query.page' () {
      await this.$nuxt.refresh()
    }
  }
})
